import { Asset } from '../types'
import { getDetachmentDateByAsset } from '../utils/asset'

export interface AssetTimestamps {
  /**
   * The timestamp when the asset was created.
   */
  createdAt: Date

  /**
   * The timestamp when the asset was updated.
   */
  updatedAt: Date

  /**
   * The timestamp when the asset was deleted.
   */
  deletedAt: Date | null

  /**
   * The timestamp when the asset was attached.
   */
  attachedAt: Date

  /**
   * The timestamp when the asset was detached.
   */
  detachedAt: Date | null
}

export default function useAssetTimestamps(asset: Asset): AssetTimestamps {
  /**
   * The timestamp when the asset was created.
   */
  const createdAt = new Date(asset.createdAt)

  /**
   * The timestamp when the asset was updated.
   */
  const updatedAt = new Date(asset.updatedAt)

  /**
   * The timestamp when the asset was deleted.
   */
  const deletedAt = asset.deletedAt ? new Date(asset.deletedAt) : null

  /**
   * The timestamp when the asset was attached.
   */
  const attachedAt = asset?.attachedAt ? new Date(asset.attachedAt) : new Date(asset.createdAt)

  /**
   * The timestamp when the asset was detached.
   */
  const detachedAt = asset?.detachedAt
    ? new Date(asset.detachedAt)
    : getDetachmentDateByAsset(asset)

  return {
    createdAt,
    updatedAt,
    deletedAt,
    attachedAt,
    detachedAt
  }
}
